import { Component, Input, OnInit } from '@angular/core';
import { joiner } from '@commons/util/helper/string';

import { ResponseModel, ResponseModelAttachment } from '../../models/responseModel';
import { Domain } from '../models/domain';
import { LinkTypeEnumeration, OwiMdr } from '../models/responseModel';
import { KnowledgeBaseOwiApiService } from '../services/knowledge-base-OWI-api.service';
import { KnowledgeBaseOwiService } from '../services/knowledge-base-OWI.service';

enum ActionType {
  INSERT = 'INSERT',
}

@Component({
  selector: 'knowledge-base-tree',
  templateUrl: 'knowledge-base-tree.component.html',
  styleUrls: ['./knowledge-base-tree.component.scss'],
})
export class KnowledgeBaseTreeComponent implements OnInit {
  readonly ActionType = ActionType;
  @Input() readonly canCopyPaste: boolean;

  LinkTypeEnumeration = LinkTypeEnumeration;

  knowledgeBaseGroups: Domain[] = [];
  knowledgeBaseDocuments: Domain[] = [];
  currentGroup: Domain | undefined;
  currentDocument: ResponseModel | undefined = undefined;
  breadcrumb: Domain[] = [];
  selectedDomainUuids: string[];
  domains: Domain[] = [];
  loading = false;
  knowledgeBaseSearchRequest = undefined;

  constructor(
    private readonly knowledgeBaseOwiApiService: KnowledgeBaseOwiApiService,
    private readonly knowledgeBaseOwiService: KnowledgeBaseOwiService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.knowledgeBaseOwiApiService.getTree().subscribe(
      (response: Domain[]) => {
        response.forEach((domain: Domain) => {
          let domainsRecursive = this.knowledgeBaseOwiService.recursiveDomainBuild(domain);
          if (domainsRecursive) {
            this.domains.push(domainsRecursive);
          }
        });
        this.openGroup();
      },
      error => {
        console.log('ERROR: ' + JSON.stringify(error));
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  resetDocument(): void {
    this.currentDocument = undefined;
  }

  copyPaste(): void {
    if (this.currentDocument) {
      this.knowledgeBaseOwiService.copyPaste(this.currentDocument);
    }
  }

  openBreadcrumbGroup(group?: Domain): void {
    if (!!group) {
      this.breadcrumb.splice(this.breadcrumb.indexOf(group) + 1);
    } else {
      this.breadcrumb = [];
    }
    this.loading = true;
    this.openGroup(group, false);
  }

  openGroup(group?: Domain, addToBreadcrumb = true): void {
    this.resetDocument();
    this.knowledgeBaseGroups = [];
    this.knowledgeBaseDocuments = [];
    if (group) {
      if (addToBreadcrumb) {
        this.breadcrumb.push(group);
      }

      if (group.children.length) {
        this.knowledgeBaseGroups = group.children.filter(group => !this.knowledgeBaseOwiService.isResponseModel(group));
        this.knowledgeBaseDocuments = group.children.filter(group => this.knowledgeBaseOwiService.isResponseModel(group));
      }
    } else {
      this.knowledgeBaseGroups = this.domains.filter(group => !this.knowledgeBaseOwiService.isResponseModel(group));
      this.knowledgeBaseDocuments = this.domains.filter(group => this.knowledgeBaseOwiService.isResponseModel(group));
    }
    this.loading = false;
  }

  openDocument(documentId: string): void {
    this.loading = true;
    this.knowledgeBaseOwiApiService.getDocument(documentId).subscribe((response: OwiMdr[]) => {
      let responseModel: OwiMdr | undefined = response.pop();
      if (responseModel) {
        const attachments = responseModel.attachments
          ? responseModel.attachments.map(owiAttachment => ({
              responseModelId: owiAttachment.mdrNum,
              name: owiAttachment.name,
              content: owiAttachment.content,
            }))
          : [];

        this.currentDocument = {
          id: responseModel.mdrNum,
          label: responseModel.libelle,
          content: responseModel.contenu,
          linkType: responseModel.typeLien,
          link: responseModel.lien,
          linkText: responseModel.texteLien,
          attachments,
        };
      }
      this.loading = false;
    });
  }

  documentActionClickFn(action: ActionType) {
    switch (action) {
      case ActionType.INSERT: {
        this.copyPaste();
        break;
      }
      // ignore
      default:
        break;
    }
  }

  getBreadcrumb(): string {
    let breadcrumb = '/';
    breadcrumb = joiner(
      this.breadcrumb.map(group => group.libelle),
      '/ '
    );

    if (this.currentDocument) {
      breadcrumb += '/' + this.currentDocument.label;
    }

    return breadcrumb;
  }
}
